import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportsFinanceByCategories: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_CATEGORIES].GET_REPORTS_FINANCE_BY_CATEGORIES,
	},
}
